import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallCalender = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.667 1.332v2.667M5.333 1.332v2.667M2 6.001h12"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.667 2.668H3.333C2.597 2.668 2 3.265 2 4.001v8.667c0 .737.597 1.333 1.333 1.333h9.334c.736 0 1.333-.596 1.333-1.333V4.001c0-.736-.597-1.333-1.333-1.333"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSmallCalender;
